<template>
    <div class="getGiftBox">
        <!--<div class="memberRuleNav">-->
            <!--<i @click="returnFn" class="iconfont iconzuojiantou"></i>-->
        <!--</div>-->
        <div class="getGiftContent">
            <div class="giftScroll">
                <div class="giftRow">
                    <div class="giftImgBox">
                        <img src="http://i1.mallcoo.cn/sp_mall/6cd7396c-6e9d-4fa9-b63b-7c6f291d1b12_375x388_1_0_80.png" >
                    </div>
                    <div class="giftRight">
                        <div class="giftRightRow"><span class="giftTitle">商品名称</span><span class="giftName">照片</span></div>
                        <div class="giftRightRow"><span class="giftTitle">礼品编号</span><span class="giftName">000000000075</span></div>
                        <div class="giftRightRow"><span class="giftTitle">扣减积分</span><span class="giftName">100</span></div>
                        <div class="giftRightRow"><span class="giftTitle">领取数量</span><span class="giftName">1</span></div>
                    </div>
                </div>
                <div class="giftRowItem">
                    <div class="giftRowTitle">兑换时间</div>
                    <div class="giftRowName">2019-11-24 15:05:55</div>
                </div>
                <div class="giftRowItem">
                    <div class="giftRowTitle">领取时间</div>
                    <div class="giftRowName">2019-12-24 15:15:55</div>
                </div>
                <div class="giftRowItem">
                    <div class="giftRowTitle">领取状态</div>
                    <div class="giftRowName">
                        <div class="giftNone">已领取</div>
                    </div>
                </div>
                <div class="textRow">
                    <div class="textL">领奖说明：</div>
                    <div class="textR">领奖说明领奖说明领奖说明领奖说明领奖说明领奖说明领奖说明领奖说明领奖说明领奖说明领奖说明领奖说明领奖说明领奖说明领奖说明</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "getGiftDetails",
        mounted() {
            document.title = "领礼详情"
        },
        methods:{
            // returnFn(){
            //     this.$router.go(-1)
            // }
        }
    }
</script>

<style lang="scss" scoped>
    .getGiftBox{
        width: 100%;
        height: 100%;
        /*.memberRuleNav{*/
            /*width: 100%;*/
            /*height: 45px;*/
            /*background-color: #6cf;*/
            /*box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.1);*/
            /*line-height: 45px;*/
        /*}*/
        /*.iconzuojiantou{*/
            /*font-size: 24px;*/
            /*color: #fff;*/
            /*margin-left: 4px;*/
            /*padding: 6px;*/
        /*}*/
        .getGiftContent{
            position: absolute;
            /*top: 45px;*/
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: #fff;
            display: flex;
            flex-direction: column;
            align-items: center;
        }
        .giftScroll{
            margin-top: 10px;
            width: 90%;
        }
        .giftImgBox{
            width: 120px;
            height: 102px;
            border: 1px solid #f5f5f5;
            img{
                width: 100%;
                height: 100%;
            }
        }
        .giftRow{
            display: flex;
        }
        .giftRight{
            flex: 1;
            margin-left:10px;
        }
        .giftRightRow{
            display: flex;
            font-size: 16px;
            height: 27px;
            .giftTitle{
                width: 80px;
                color: #888;
                line-height: 27px;
            }
            .giftName{
                flex: 1;
                color: #333;
                line-height: 27px;
            }
        }
        .giftRowItem{
            display: flex;
            height: 28px;
            .giftRowTitle{
                width: 130px;
                line-height: 28px;
                color: #888;
            }
            .giftRowName{
                line-height: 28px;
                color: #333;
                flex: 1;
                display: flex;
                align-items: center;
            }
        }
        .giftNone{
            width: 55px;
            height: 23px;

            font-size: 12px;

            border: 1px solid #d9ecff;
            text-align: center;
            line-height: 23px;
            border-radius: 3px;
            background-color: #ecf5ff;
            color: #409eff;
        }
        .iptStyle{
            outline: none;
            width: 90%;
            height: 96%;
        }
        .textRow{
            margin-top: 20px;
            width: 100%;
            display: flex;
            border: 1px solid #2db7f5;
            padding: 5px;
            font-size: 14px;
            box-sizing: border-box;
        }
        .textL{
            flex: 2;
            color: #666;
        }
        .textR{
            color: #333;
            flex: 5;
        }
    }
</style>
